import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';

class PayrollItemColumnAPI extends DIApi {
  controllerName = 'PayrollItemColumns';
  /**
   * Get dữ liệu danh sách cột công thức
   * @returns
   * NNLINH 01.07.2022
   */
  async getPayrollItemColumn(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Sort: 'payroll_item_column_code',
        Columns: 'payroll_item_column_code,payroll_item_name,formula,payroll_item_column_type,payroll_item_column_id',
        type: 0,
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu danh sách công thức mẫu 09
   */
  async getFormulaMS09() {
    commonFn.mask();
    let request = {
      url: this.getAPIUrl() + '/formulaMS09',
    };
    let res = await httpClient.getAsync(request);
    commonFn.unmask();
    return res;
  }
}
export default new PayrollItemColumnAPI();
